<template>
    <div class="table-list bill-list">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <bill-detail :billId="billId" :phone="tenantPhone"></bill-detail>
        <modal class="delete-bill" :display="modalStatus.deleteBill" @modalStatus="closeAlarmModal" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>帳單刪除</h1>
            <div class="content">
                確定刪除 ”{{billHouseName}}”的帳單嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteBill(), $analytics.logEvent('帳單刪除', { screen_name: '帳單刪除'})">確認</button>
                <button class="border-button" @click="closeAlarmModal">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="create-date">建立時間</span>
            <span class="house">房源名稱</span>
            <span class="name">帳單名稱</span>
            <span class="pay-time">繳款時間</span>
            <span class="tenant">租客</span>
            <span class="state">狀態</span>
            <span class="amount">帳單金額</span>
            <span class="notify-status">催款狀態</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && financialBill.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-show="financialBill.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="create-date">{{getFormatDate(list.createdTime)}}</span>
                    <span class="house">{{list.houseName}}</span>
                    <span class="name">{{list.billName}}</span>
                    <span class="pay-time">{{list.actualPayTime?list.actualPayTime:'-'}}</span>
                    <span class="tenant">{{list.tenantName}}</span>
                    <span class="state body blue" v-if="list.billStatus == 'COMPLETELY_PAID'">已繳</span>
                    <span class="state body gray" v-if="list.billStatus == 'UNPAID'">未繳</span>
                    <span class="state body red" v-if="list.billStatus == 'OVERDUE'">欠款</span>
                    <span class="amount">{{toCurrency(list.totalBillAmount)}}</span>
                    <span v-if="list.hadSent" class="notify-status">已催款</span>
                    <span v-else class="notify-status"></span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="setBillDetail(list.billCid), tenantPhone = list.tenantPhone">帳單明細</li>
                                <li v-if="list.billStatus == 'OVERDUE'" @click="sendMsg(list.tenantPhone, list.billCid), $analytics.logEvent('欠款催繳', { screen_name: '欠款催繳'})">欠款催繳</li>
                                <li v-if="list.billStatus != 'COMPLETELY_PAID'" @click="openAlarmModal(), billHouseName = list.houseName, billId = list.billCid">帳單刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import editAccounting from '@/components/widge/editAccounting.vue';
import BillDetail from '@/components/widge/BillDetail.vue';

import { 
    apiSendMsg,
    apiHadSent,
    apiDeleteBill
    } from "@/apis/api.js"; 


import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            selected: 0,
            tenantPhone: null,
            billId: null,
            billHouseName: null,
            filterTotal: {
                all: 0,
                overdue: 0,
                paid: 0,
                unpaid: 0,
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            modalStatus: {
                deleteBill: false
            },
        }
    },
    props: {
        state: ''
    },
    watch: {
        filterByWord:{
            handler: function (val) {
                if( this.state == 'ALL' ){
                    this.$store.dispatch('setFinancialBillFilterResultTotal', {type: 'ALL', count: val.length})
                }else if( this.state == 'OVERDUE' ){
                    this.$store.dispatch('setFinancialBillFilterResultTotal', {type: 'OVERDUE', count: val.length})
                }else if( this.state == 'COMPLETELY_PAID' ){
                    this.$store.dispatch('setFinancialBillFilterResultTotal', {type: 'COMPLETELY_PAID', count: val.length})
                }else if( this.state == 'UNPAID' ){
                    this.$store.dispatch('setFinancialBillFilterResultTotal', {type: 'UNPAID', count: val.length})
                }else if( this.state == 'PART' ){
                    this.$store.dispatch('setFinancialBillFilterResultTotal', {type: 'PART', count: val.length})
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setFinancialBillFilterDefault')
        },
        // getFormatDate: function (time){
        //     var formatDate = [];
        //     var date = new Date(time);
        //     //一般日期 年 月 天 時 分
        //     formatDate[0] = date.getFullYear();
        //     formatDate[1] = date.getMonth()+1;
        //     formatDate[2] = date.getDate();
        //     formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
        //     formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
        //     //月及天兩位數
        //     formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
        //     formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
        //     // console.log(formatDate[3] )
        //     //換算時區 台灣-8
        //     if(formatDate[3] - 8 < 0){
        //         formatDate[3] = 24+(formatDate[3]-8);
        //         formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
        //     }else{
        //         formatDate[3] = formatDate[3]-8;
        //         formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
        //     }
        //     return formatDate[0]+'.'+formatDate[5]+'.'+formatDate[6];
        // },
        setBillDetail: function (billCid) {
            this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
            this.billId = billCid
            this.$store.dispatch('setModalStatus', {state: true, type: 'billDetail'})
            this.$store.commit('modalStatus/set_modal_mode', true)
            document.getElementsByClassName('financial-bill')[0].style.zIndex = '9'
        },
        sendMsg: function (phone, billCid) {
            let data = {
                "account": phone,
                "title":"",
                "message":"您有一筆租金尚未繳款，請立即開啟確認"
            }
    
            apiSendMsg(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '催款訊息送出成功'
                    this.setHadSent(billCid)
                }else{
                    this.alart.error = true
                    this.msg.success = '催款訊息送出失敗'
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setHadSent: function (billCid) {
            let data = {
                "billCid" : billCid,
                "hadSent" : true
            }

            apiHadSent(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.$store.dispatch('getFinancialBillMgtList')
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        openAlarmModal: function () {
            this.modalStatus.deleteBill = true
            document.getElementsByClassName('financial-bill')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlarmModal: function () {
            this.$store.commit('modalStatus/set_modal_mode', false)
            this.modalStatus.deleteBill = false
        },
        deleteBill: function () {
            this.$analytics.logEvent('帳單刪除', { screen_name: '帳單刪除'})
            let data = {
                "billCid": this.billId
            }
            apiDeleteBill(data)
            .then( res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('getFinancialBillMgtList')
                    this.closeAlarmModal()
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getFormatDate: function (date){
            var formatDate = [];
            var date = new Date(date);
            // var date = new Date(Date.parse(date));
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
            // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }else{
        //         return 0
        //     }
            
        // },
    },
    computed: {
        filterByState: function () {
            return this.financialBill.filter((item) => {
                // console.log(item)
                if( this.state == 'OVERDUE' ){
                    if( item.billStatus == 'OVERDUE' ){
                        return item
                    }
                }else if( this.state == 'COMPLETELY_PAID' ){
                    if( item.billStatus == 'COMPLETELY_PAID' ){
                        return item
                    }
                }else if( this.state == 'UNPAID' ){
                    if( item.billStatus == 'UNPAID' ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByCounty: function () {
            return this.filterByState.filter((item) => {
                if(this.filterQuery.county){
                    if(item.city == this.filterQuery.county){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district == this.filterQuery.district ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByAmount: function () {
            return this.filterByDistrict.filter((item) => {
                if( this.filterQuery.amount ){
                    if( this.filterQuery.amount[1] >= 100000){
                        if( this.filterQuery.amount[0] <= item.totalBillAmount){
                            return item
                        }
                    }else{
                        if( this.filterQuery.amount[0] <= item.totalBillAmount && this.filterQuery.amount[1] >= item.totalBillAmount ){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByAmount.filter((item) => {
                if( this.filterWord ){
                    if( item.houseName.includes(this.filterWord) || item.billName.includes(this.filterWord) || item.tenantName.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            financialBill: 'GET_FINANCIAL_BILL_MGT_LIST',
            filterQuery: 'GET_FINANCIAL_BILL_MGT_FILTER_QUERY',
            filterWord: 'GET_FINANCIAL_BILL_MGT_FILTER_WORD',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        AlartMsg,
        Modal,
        BillDetail
    }
}
</script>
<style lang="scss" scoped>
    .table-list.bill-list{
        // .table-list-title .house:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .house:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        margin-bottom: 150px;
        #modal.delete-bill{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #676362;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .table-list-title .create-date,
        .table-list-body ul li .create-date{
            width: 80px;
            margin-right: 41px;
        }
        .table-list-title .house,
        .table-list-body ul li .house{
            position: relative;
            width: 130px;
            margin-right: 55px;
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 88px;
            margin-right: 45px;
        }
        .table-list-title .pay-time,
        .table-list-body ul li .pay-time{
            width: 80px;
            margin-right: 51px;
        }
        .table-list-title .tenant,
        .table-list-body ul li .tenant{
            width: 60px;
            margin-right: 51px;
        }
        .table-list-title .amount,
        .table-list-body ul li .amount{
            width: 56px;
            margin-right: 55px;
        }
        .table-list-body ul li .amount{
            text-align: right;
        }
        .table-list-title .notify-status,
        .table-list-body ul li .notify-status{
            width: 56px;
            margin-right: 61px;
            color: #a8a5a4;
        }
        
        .table-list-title .state,
        .table-list-body ul li .state{
            width: 76px;
            margin-right: 61px;
        }
        .table-list-body ul li .state.body{
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }
        .table-list-body ul li .state.blue{
            background-color: rgba(113, 170, 229, 0.1);
            color: #71aae5;
        }
        .table-list-body ul li .state.red{
            background-color: rgba(255, 146, 117, 0.1);
            color: #fc7171;
        }
        .table-list-body ul li .state.gray{
            background-color: #f3f3f3;
            color: #676362;
        }
    }
    @media screen and (max-width: 1280px){
        .table-list.bill-list{
            .table-list-title .house,
            .table-list-body ul li .house{
                margin-right: 48px;
            }
            .table-list-title .tanant,
            .table-list-body ul li .tanant{
                margin-right: 54px;
            }
            .table-list-title .phone,
            .table-list-body ul li .phone{
                margin-right: 64px;
            }
            .table-list-title .address,
            .table-list-body ul li .address{
                margin-right: 44px;
            
            }
            .table-list-title .rent,
            .table-list-body ul li .rent{
                margin-right: 32px;
            }
            .table-list-title .leave-date,
            .table-list-body ul li .leave-date{
                margin-right: 70px;
            }
        }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/financialManagement/financialBillList.vue